export enum EFilterNames {
	BRAND = 'Brand',
	MODEL_NAME = 'Model Name',
	COLOR = 'Color',
	FUEL_TYPE = 'Fuel Type',
	TRANSMISSION = 'Transmission',
	SORT = 'Sort',
	SEATS = 'Seats',
	AVERAGE_FUEL_CONSUMPTION = 'Average Fuel Consumption',
	SEGMENT = 'Segment',
	GROUP = 'Group',
	DOORS = 'Doors',
	PRICE = 'Price',
}

export enum ESortValues {
	MOST_POPULAR = 'most_popular',
	PRICE_ASC = 'price_asc',
	PRICE_DESC = 'price_desc',
}

export interface ICarSelectedFilters {
	parameter: IProductParameterModel
	values: string[] | number[]
	min?: number
	max?: number
}

export interface IPriceRange {
	name: string
	value: string
	min: number
	max?: number
}

export interface ICarSorting {
	name: string
	value: ESortValues
}
